import React, { useState } from "react";
import "./GlobalSettingsPage.scss";
import InvoiceSettings from "./InvoiceSettings/InvoiceSettings";
import ExpenseSettings from "./ExpensesSettings/ExpensesSettings";
import TaskSettings from "./TaskSettings/TaskSettings";
import LabelSettings from "./LabelSettings/LabelSettings";
import RightsSettings from "./RightsSettings/RightsSettings";
import VisibilitySettings from "./VisibilitySettings/VisibilitySettings";
import EmailConfigSettings from "./EmailConfigSettings/EmailConfigSettings";
import { Labels } from "../Labels/Labels";
import CaseSettings from "./CaseSettings/CaseSettings";
import AlertSettings from "./AlertSettings/AlertSettings";

const GlobalSettingsPage = () => {
  const [activeTab, setActiveTab] = useState("rights");

  const renderContent = () => {
    switch (activeTab) {
      case "rights":
        return <RightsSettings />;
      case "invoice":
        return <InvoiceSettings />;
      case "expense":
        return <ExpenseSettings />;
      case "task":
        return <TaskSettings />;
      case "labelpriority":
        return <LabelSettings />;
      case "label":
        return <Labels/>;
      case "emailConfig":
        return <EmailConfigSettings />;
      case "caseConfig":
        return <CaseSettings />;
      case "alerts":
        return <AlertSettings />;
      // case 'visibility':
      //     return <VisibilitySettings />;
      default:
        return null;
    }
  };

  return (
    <div className="global-settings">
      <h1>Global Settings</h1>
      <div className="settings-tabs">
        <button
          className={activeTab === "rights" ? "active" : ""}
          onClick={() => setActiveTab("rights")}
        >
          Rights
        </button>
        <button
          className={activeTab === "caseConfig" ? "active" : ""}
          onClick={() => setActiveTab("caseConfig")}
        >
          Case Configuration
        </button>
        <button
          className={activeTab === "invoice" ? "active" : ""}
          onClick={() => setActiveTab("invoice")}
        >
          Invoices
        </button>
        <button
          className={activeTab === "expense" ? "active" : ""}
          onClick={() => setActiveTab("expense")}
        >
          Expenses
        </button>
        <button
          className={activeTab === "task" ? "active" : ""}
          onClick={() => setActiveTab("task")}
        >
          Tasks
        </button>
          <button
          className={activeTab === "label" ? "active" : ""}
          onClick={() => setActiveTab("label")}
        >
          Labels
        </button>
        <button
          className={activeTab === "labelpriority" ? "active" : ""}
          onClick={() => setActiveTab("labelpriority")}
        >
          Label Priority Level
        </button>
       
         <button
          className={activeTab === "emailConfig" ? "active" : ""}
          onClick={() => setActiveTab("emailConfig")}
        >
          Invoice Email Configuration
        </button>

        <button
          className={activeTab === "alerts" ? "active" : ""}
          onClick={() => setActiveTab("alerts")}
        >
          Alerts
        </button>

        

        {/* <button
                    className={activeTab === 'visibility' ? 'active' : ''}
                    onClick={() => setActiveTab('visibility')}
                >
                    Visibility
                </button> */}
      </div>

      <div className="settings-section">{renderContent()}</div>
    </div>
  );
};

export default GlobalSettingsPage;
